

import "../../Foundation/stylable/colors.st.css.js";
import "../../Text/Text.st.css.js";
import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_153_0_SegmentedToggleButton";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_153_0_SegmentedToggleButton__root","prefix":"wds_1_153_0_SegmentedToggleButton__prefix"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-segmented-toggle-border-radius-medium":"--wds-segmented-toggle-border-radius-medium","wds-segmented-toggle-border-radius-small":"--wds-segmented-toggle-border-radius-small","wds-segmented-toggle-size-medium":"--wds-segmented-toggle-size-medium","wds-segmented-toggle-size-small":"--wds-segmented-toggle-size-small","wds-segmented-toggle-padding-horizontal-medium":"--wds-segmented-toggle-padding-horizontal-medium","wds-segmented-toggle-padding-horizontal-small":"--wds-segmented-toggle-padding-horizontal-small","wds-space-100":"--wds-space-100","wds-color-fill-standard-tertiary":"--wds-color-fill-standard-tertiary","wds-color-fill-standard-tertiary-hover":"--wds-color-fill-standard-tertiary-hover","wds-color-text-standard-primary":"--wds-color-text-standard-primary","wds-color-text-disabled":"--wds-color-text-disabled","wds-color-border-standard-secondary-active":"--wds-color-border-standard-secondary-active","wds-color-border-standard-secondary-disabled":"--wds-color-border-standard-secondary-disabled","wds-color-border-standard-secondary-hover":"--wds-color-border-standard-secondary-hover","wds-shadow-focus-standard":"--wds-shadow-focus-standard"}; 




